<style>
    #customer {
        /* padding: 30px 30px 8px 30px !important; */
        height: calc(100vh - 128px) !important;
    }

    #customer .q-table__middle {
        overflow-y: hidden !important;
        overflow-x: auto !important;
        height: calc(100% - 48px) !important;
        width: 100%;
    }

    #customer .q-table {
        overflow: hidden !important;
        height: 100% !important;
        width: 100%;
    }

    #customer tbody {
        display: block;
        max-height: calc(100vh - 300px);
        height: 100%;
        width: 100%;
        overflow: auto;
        webkit-overflow-scrolling: touch;
        will-change: scroll-position;
    }

    #customer .q-table thead {
        height: 48px;
        display: block;
    }

    #customer .q-table thead tr {
        width: 100%;
        display: table;
    }

    #customer .q-table tbody tr {
        width: 100%;
        display: table; /*table-row*/
    }

    #customer .q-table th, #customer .q-table tbody td {
        font-size: 0.95rem;
    }

    #customer .q-table th, #customer .q-table td {
        padding: 7px 8px;
    }

    #customer .q-table td {
        word-wrap: break-word;
        word-break: break-all;
        white-space: normal;
    }

    #customer .q-table__bottom {
        color: #888;
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 0 15px;
    }

    #customer .q-table__bottom, #customer .q-table__bottom .q-if {
        font-size: 0.88rem;
    }
</style>
<template>
    <q-page id="customer" padding :style="{padding:screenType?'30px 30px 8px 30px!important':'8px'}">
        <q-card class="fit">
            <q-card-section style="height: 60px;padding:10px 15px;">
                <q-btn @click="btnClick(0,-1)" :label="dTitle[0]" icon="fas fa-plus" color="positive" class="q-px-sm"
                       dense>
                    <!--<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{}}</q-tooltip>-->
                </q-btn>
                <!--<q-btn @click="btnClick(2,-1)" icon="delete_forever" :disable="!selected||selected.length==0" color="red" class="q-ml-md" round dense>
                    <q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{dTitle[2]}}</q-tooltip>
                </q-btn>-->
                <q-input v-model="keyword" @keyup.enter="getData(1)" :placeholder="$t('key')" maxlength="15"
                         style="width:210px;float:right;" rounded outlined dense>
                    <template v-slot:after>
                        <q-btn @click="getData(1)" icon="fa fa-search" color="white" text-color="primary" round dense/>
                    </template>
                </q-input>
            </q-card-section>
            <q-separator/>
            <q-card-section class="q-pa-none" style="height:calc(100% - 60px);">
                <!-- :selected.sync="selected" selection="multiple"-->
                <q-table class="fit" :data="listData" :columns="columns" :loading="loading" :pagination.sync="page"
                         :rows-per-page-options="[15,20,30]" row-key="id">
                    <tr slot="header" slot-scope="props">
                        <!--<q-th style="width:4%;"><q-checkbox v-if="props.multipleSelect" v-model="props.selected" indeterminate-value="some"/></q-th>-->
                        <q-th key="id" :props="props" style="width:6%;min-width: 50px">ID</q-th>
                        <q-th key="customerName" :props="props" style="width:27%;min-width: 200px">{{$t('customer.name')}}</q-th>
                        <q-th key="timeZone" :props="props" style="width:20%;min-width: 200px">{{$t('customer.timeZone')}}</q-th>
                        <q-th key="createTime" :props="props" style="width:18%;min-width: 200px">{{$t('createTime')}}</q-th>
                        <q-th key="updateTime" :props="props" style="width:18%;min-width: 200px">{{$t('updateTime')}}</q-th>
                        <q-th key="opt" :props="props" style="width:11%;min-width:164px;">{{$t('opt')}}</q-th>
                    </tr>
                    <q-tr slot="body" slot-scope="props" :props="props">
                        <!--<q-td style="width:4%;"><q-checkbox v-model="props.selected"/></q-td>-->
                        <!--<q-td key="id" :props="props" style="width:6%;">{{
                            (props.row.__index+1)+(curPage-1)*page.rowsPerPage }}
                        </q-td>-->
                        <q-td key="id" :props="props" style="width:6%;min-width: 50px">{{ props.row.id }}</q-td>
                        <q-td key="customerName" :props="props" style="width:27%;min-width: 200px">{{ props.row.customerName }}</q-td>
                        <q-td key="timeZone" :props="props" style="width:20%;min-width: 200px">{{ props.row.timeZone }}</q-td>
                        <q-td key="createTime" :props="props" style="width:18%;min-width: 200px">{{ props.row.createTime
                            |parseDateTime}}
                        </q-td>
                        <q-td key="updateTime" :props="props" style="width:18%;min-width: 200px">{{ props.row.updateTime
                            |parseDateTime}}
                        </q-td>
                        <q-td key="opt" :props="props" style="width:11%;min-width:164px;">
                            <q-btn @click="btnClick(3,props.rowIndex)" icon="fa fa-search" color="positive" size="sm"
                                   flat round dense>
                                <q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{$t('detail')}}
                                </q-tooltip>
                            </q-btn>
                            <q-btn @click="btnClick(1,props.rowIndex)" icon="fas fa-edit" color="amber-7"
                                   class="q-ml-sm" size="sm" flat round dense>
                                <q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{$t('modify')}}
                                </q-tooltip>
                            </q-btn>
                            <q-btn @click="btnClick(4,props.rowIndex)" icon="fas fa-user-cog" color="primary"
                                   class="q-ml-sm" size="sm" flat round dense>
                                <q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{dTitle[4]}}
                                </q-tooltip>
                            </q-btn>
                            <q-btn @click="btnClick(2,props.rowIndex)" icon="fas fa-trash-alt" color="red"
                                   class="q-ml-sm" size="sm" flat round dense>
                                <q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{$t('delete')}}
                                </q-tooltip>
                            </q-btn>
                        </q-td>
                    </q-tr>
                    <div slot="pagination" slot-scope="props" class="row flex-center q-py-sm">
                        <q-btn @click="pageClick(0)" :disable="curPage<=1" icon="fas fa-arrow-left" color="primary"
                               size="sm" round dense/>
                        <div class="q-mx-md" style="font-size: small"> {{ curPage }} / {{ totalPage }}</div>
                        <q-btn @click="pageClick(1)" :disable="nextPage" icon="fas fa-arrow-right" color="primary"
                               size="sm" round dense/>
                    </div>
                </q-table>
            </q-card-section>
        </q-card>

        <q-dialog v-model="dialogStatus" persistent transition-show="scale" transition-hide="scale">
            <q-card  :class="[screenType?'q-pa-lg':'q-pa-sm']"
                    :style="{minWidth:screenType?'450px':'85vw',width:screenType?'':'65vw'}">
                <q-card-section>
                    <div class="text-h6">{{dTitle[dialogType]}}</div>
                </q-card-section>
                <q-card-section class="fit scroll" style="max-height:60vh;">
                    <div v-if="dialogType<2">
                        <q-input ref="name" v-model.trim="form.customerName" class="q-mt-sm"
                                 :label="$t('customer.name')" maxlength="20" counter :placeholder="$t('customer.name')"
                                 outlined
                                 :rules="[val => !!val || $t('msg.input_msg'), val => val.length<=20&&val.length>=2 || $t('customer.msg_name')]"
                                 lazy-rules/>
                        <q-select ref="time" v-model="form.timeZone" :label="$t('customer.timeZone')"
                                  :options="$t('customer.timeZones')" option-value="val" option-label="name" emit-value
                                  map-options outlined
                                  :rules="[val => !!val || $t('msg.select'),]" class="q-mt-sm" lazy-rules/>
                        <div>
                            <label>语言：</label>
                            <q-radio v-model="form.language" val="zh-CN" label="中文"/>
                            <q-radio v-model="form.language" val="en-US" label="英文"/>
                        </div>
                        <q-radio v-if="dialogType===0" v-model="adminType" :val="0" label="选择“客户管理员”作为管理员"
                                 class="q-mt-sm text-grey-7"/>
                        <br v-if="dialogType===0"/>
                        <q-select ref="admin" v-if="adminType===0&&dialogType===0"
                                  v-model="form.userId"
                                  :label="$t('customer.user')"
                                  @filter="filterFn"
                                  :options="userOpt"
                                  option-value="id" option-label="name"
                                  emit-value map-options outlined multiple use-chips
                                  :rules="[val => !!val || $t('msg.select'),]"
                                  clearable
                                  class="q-mt-sm" lazy-rules/>
                        <q-radio v-if="dialogType===0" v-model="adminType" :val="1" label="创建“新的客户管理员”作为管理员"
                                 class="q-mt-sm text-grey-7"/>
                        <br v-if="dialogType===0"/>
                        <q-input ref="account" v-if="dialogType===0&&adminType===1" v-model.trim="form.account"
                                 :label="$t('user.name')" maxlength="20" counter :placeholder="$t('user.name')" outlined
                                 :rules="[val => !!val || $t('msg.input_msg'), val => val.length<=20&&val.length>=4 || $t('customer.msg_account')]"
                                 lazy-rules class="q-mt-sm"/>
                        <q-input ref="user" v-if="dialogType===0&&adminType===1" v-model.trim="form.user"
                                 :label="$t('customer.user')" maxlength="20" counter :placeholder="$t('customer.user')"
                                 outlined
                                 :rules="[val => !!val || $t('msg.input_msg'), val => val.length<=20&&val.length>=2 || $t('customer.msg_user')]"
                                 lazy-rules class="q-mt-sm"/>
                        <!-- <q-input ref="email" v-if="dialogType===0&&adminType===1" v-model.trim="form.email"
                                 :label="$t('customer.email')" @keyup.native="keyEnter(1,$event)" maxlength="320" counter
                                 :placeholder="$t('customer.email')" outlined
                                 :rules="[val=>!!val || $t('msg.input_msg'), val=>val.length<=320&&val.length>=8 || $t('customer.msg_email'), val=>valid(1, val) || $t('customer.err_email')]"
                                 lazy-rules class="q-mt-sm"/> -->
                         <q-input ref="email" v-if="dialogType===0&&adminType===1" v-model.trim="form.email"
                                 :label="$t('customer.email')" @keyup.native="keyEnter(1,$event)" maxlength="320" counter
                                 :placeholder="$t('customer.email')" outlined
                                 :rules="[val=>!!val || $t('msg.input_msg'), val=>val.length<=320&&val.length>=8 || $t('customer.msg_email'), val=>valid(1, val) || $t('customer.err_email')]"
                                 lazy-rules class="q-mt-sm"/>
                                 <!-- 手机号码输入区域 -->
                        <div class="row">
                            <q-select
                            filled v-if="dialogType===0&&adminType===1" v-model="nations"
                            :label="$t('customer.nation')" :options="nationsOpt" option-value="val" option-label="name"
                            clearable use-input input-debounce="0" emit-value 
                            :rules="null" 
                            @filter="filterFnNations"
                            class="q-mt-sm  q-mr-sm col-6">
                            <template v-slot:no-option>
                              <q-item>
                                <q-item-section class="text-grey">
                                  No results
                                </q-item-section>
                              </q-item>
                            </template>
                          </q-select>
                            <q-input ref="phone" v-if="dialogType===0&&adminType===1" v-model.trim="form.phone"
                                 :label="$t('customer.phone')" @keyup.native="keyEnter(0,$event)" maxlength="11" counter
                                 :placeholder="$t('customer.phone')" outlined
                                 :rules="null"
                                 lazy-rules class="q-mt-sm col"/>
                                 <!-- :rules= "[val=>!!val || $t('msg.input_msg'), val=>val.length >=3 && val.length <=11 || $t('customer.msg_phone'), val=>valid(0, val) || $t('customer.err_phone')] " -->

                        </div>
                        <q-input ref="pw" v-if="dialogType===0&&adminType===1" v-model.trim="form.password"
                                 type="password" :label="$t('customer.pw')" maxlength="20" counter
                                 :placeholder="$t('customer.pw')" outlined
                                 :rules="[val => !!val || $t('msg.input_msg'), val => val.length<=20&&val.length>=4 || $t('customer.msg_pw')]"
                                 lazy-rules class="q-mt-sm"/>
                        <q-input ref="pw1" v-if="dialogType===0&&adminType===1" v-model.trim="form.password1"
                                 type="password" :label="$t('customer.pw1')" maxlength="20" counter
                                 :placeholder="$t('customer.pw1')" outlined
                                 :rules="[val => !!val || $t('msg.input_msg'), val => val.length<=20&&val.length>=4 || $t('customer.msg_pw'), val => val===form.password || $t('customer.err2')]"
                                 lazy-rules class="q-mt-sm"/>

                        <!-- logo上传区域 -->
                    <div>
                        <q-toggle
                            v-model="logoAraedisplay"
                            label="Logo上传"
                            color="green"
                            style="color: #757575 !important;"
                        />
                    </div>
                    <div v-if="logoAraedisplay" class="logo_area row">
                        <q-uploader style="display: none;" ref="upload" class="upload q-mb-sm full-width"  @added="(files)=>{addFiles(files)}" :accept="logoAccept"/>
                        <div class="col-4">
                            <q-select class="col-12 q-mb-sm" v-model="selServer"  :options="serverList" option-value="id" option-label="name" emit-value map-options outlined rounded dense>
                                <template v-slot:prepend><span style="font-size:14px;">选择MS：</span></template>
                            </q-select>
                            <q-btn @click="add()" color="primary" class="col-12 btn-fixed-width" style="width: 100%;">上传图片</q-btn>                                
                        </div>
                        <div class="col-5 offset-2"  v-if="logoUploadStatus || form.logoPath">
                            <div class="justify-between items-center" style="display: flex;">
                                <span>最终效果图：</span>
                                <q-btn v-if="logoUploadStatus || form.logoPath" @click="picRemove()" size="14px" flat dense round icon="fas fa-trash-alt" color="red"/>
                            </div>
                            <div  class="col-12" style="height: 42px;margin-top: 5px;box-shadow: 0 1px 5px rgba(0,0,0,0.2), 0 2px 2px rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12);">
                                <img height="100%" @click="imgDialogDisaplay = true" :src="form.logoPath == null?logolistdata.src:form.logoPath" style="object-fit: contain;"/>
                            </div>
                        </div>
                    </div>
                    <q-dialog v-model="imgDialogDisaplay">
                        <q-card style="min-width: 650px;max-width: 85vw;padding: 15px;">
                            <q-card-section>
                                <div class="text-h6">预览</div>
                            </q-card-section>
                            <q-card-section style="text-align: center; height: 50vh;padding: 10px 50px;">
                                <img height="100%" width="100%" style="background: rgb(0, 0, 0); object-fit: contain;" :src="form.logoPath == null?logolistdata.src:form.logoPath"></img>
                            </q-card-section>
                            <q-card-section align="right" style="padding: 15px 50px">
                                <q-btn  @click="imgDialogDisaplay = false" color="primary" style="padding:0 30px;" class="btn-fixed-width" label="取消"></q-btn>
                            </q-card-section>
                        </q-card>
                    </q-dialog>
                    </div>
                    
                    <div v-if="dialogType===4">
                        <q-list v-if="personList&&personList.length>0" bordered separator class="rounded-borders"
                                style="min-width:600px;overflow-x:auto;">
                            <q-item v-for="(item,index) in personList" :key="index" class="q-py-md" clickable>
                                <q-item-section class="col-3">
                                    <q-item-label class="text-weight-medium">
                                        {{item.userName}}<span v-if="item.relationType==='DMAS_ADMIN'"
                                                               class="text-primary"
                                                               style="font-size:13px;margin-left:7px;">{{'管理员'}}</span>
                                    </q-item-label>
                                    <q-item-label caption style="margin-top:7px;">{{$t('user.name')}}：{{item.account}}
                                    </q-item-label>
                                </q-item-section>
                                <q-item-section top>
                                    <q-item-label lines="1" class="text-grey-8">
                                        {{$t('customer.phone')}}：{{item.phone}}
                                    </q-item-label>
                                    <q-item-label caption lines="1" style="margin-top:7px;">
                                        {{$t('createTime')}}：{{item.createTime |parseDateTime}}
                                    </q-item-label>
                                </q-item-section>
                                <q-item-section top>
                                    <q-item-label lines="1" class="text-grey-8">
                                        {{$t('customer.email')}}：{{item.email}}
                                    </q-item-label>
                                    <q-item-label caption lines="1" style="margin-top:7px;">
                                        {{$t('updateTime')}}：{{item.updateTime |parseDateTime}}
                                    </q-item-label>
                                </q-item-section>
                                <q-item-section side>
                                    <div class="text-grey-8 q-gutter-xs">
                                        <!-- <q-btn v-if="item.relationType==='DMAS_ADMIN'" @click="btnClick(5,index)"
                                               size="14px" flat dense round icon="fa fa-edit" color="amber-7"/> -->
                                        <q-btn v-if="item.relationType!='DMAS_ADMIN'" @click="btnClick(6,index)"
                                               size="14px" flat dense round icon="fas fa-trash-alt" color="red"/>
                                    </div>
                                </q-item-section>
                            </q-item>
                        </q-list>
                        <div v-else>{{$t('null')}}</div>
                    </div>
                    <div v-if="dialogType==3" style="line-height:38px;font-size:15px;margin:0 auto;">
                        <q-field borderless>
                            <template v-slot:prepend><span style="font-size:15px;">{{$t('customer.name')}}：</span>
                            </template>
                            <template v-slot:control>
                                <div class="self-center full-width no-outline" tabindex="0">{{form.customerName}}</div>
                            </template>
                        </q-field>
                        <q-field borderless>
                            <template v-slot:prepend><span style="font-size:15px;">{{$t('customer.timeZone')}}：</span>
                            </template>
                            <template v-slot:control>
                                <div class="self-center full-width no-outline" tabindex="0">
                                    {{form.timeZone?form.timeZone:$t('null')}}
                                </div>
                            </template>
                        </q-field>
                        <q-field borderless>
                            <template v-slot:prepend><span style="font-size:15px;">{{$t('createTime')}}：</span>
                            </template>
                            <template v-slot:control>
                                <div class="self-center full-width no-outline" tabindex="0">{{form.createTime
                                    |parseDateTime}}
                                </div>
                            </template>
                        </q-field>
                        <q-field borderless>
                            <template v-slot:prepend><span style="font-size:15px;">{{$t('updateTime')}}：</span>
                            </template>
                            <template v-slot:control>
                                <div class="self-center full-width no-outline" tabindex="0">{{form.updateTime
                                    |parseDateTime}}
                                </div>
                            </template>
                        </q-field>
                    </div>
                </q-card-section>
                <q-card-actions align="right" class="bg-white text-teal">
                    <q-btn :label="$t('close')" :flat="dialogType!=3&&dialogType!=4" color="primary" class="q-mr-md"
                           v-close-popup/>
                    <q-btn v-if="dialogType!=3&&dialogType!=4" @click="confirm()" :label="$t('ok')"
                           :disable="btnDisable" icon="fas fa-check" color="primary"/>
                </q-card-actions>
            </q-card>
        </q-dialog>

<!-- 修改管理员信息区域 -->
        <q-dialog v-model="dialogStatus2" persistent transition-show="scale" transition-hide="scale">
            <q-card class="q-pa-lg" style="min-width:450px;width:65vw;">
                <q-card-section>
                    <div class="text-h6">{{$t('customer.dialog')[5]}}</div>
                </q-card-section>
                <q-card-section class="fit scroll" style="max-height:60vh;">
                    <div>
                        <!-- <q-input ref="cAccount" v-model.trim="form.account" class="q-mt-sm" :label="$t('user.name')" maxlength="20" counter :placeholder="$t('user.name')" outlined
                            :rules="[val => !!val || $t('msg.input_msg'), val => val.length<=20&&val.length>=4 || $t('user.msg_name')]" lazy-rules/> -->
                        <q-input ref="cName" v-model.trim="form.userName" class="q-mt-sm" :label="$t('customer.user')"
                                 maxlength="20" counter :placeholder="$t('customer.user')" outlined
                                 :rules="[val => !!val || $t('msg.input_msg'), val => val.length<=20&&val.length>=2 || $t('customer.msg_user')]"
                                 lazy-rules/>
                        <q-input ref="cEmail" v-model.trim="form.email" @keyup.native="keyEnter(1,$event)"
                                 class="q-mt-sm" :label="$t('customer.email')" maxlength="40" counter
                                 :placeholder="$t('customer.email')" outlined
                                 :rules="null"
                                 lazy-rules/>
                                 <!-- :rules="[val=>!!val || $t('msg.input_msg'), val=>val.length<=40&&val.length>=8 || $t('customer.msg_email'), val=>valid(1, val) || $t('customer.err_email')]" -->

                        <q-input ref="cPhone" v-model.trim="form.phone" @keyup.native="keyEnter(0,$event)"
                                 class="q-mt-sm" :label="$t('customer.phone')" maxlength="11" counter
                                 :placeholder="$t('customer.phone')" outlined
                                 :rules="null"
                                 lazy-rules/>
                                 <!-- :rules="[val=>!!val || $t('msg.input_msg'), val=>val.length >= 3 &&val.length<=11 || $t('customer.msg_phone'), val=>valid(0, val) || $t('customer.err_phone')]" -->
                        
                        <q-toggle v-model="isPW" label="重置密码" checked-icon="fas fa-check" unchecked-icon="fas fa-times"
                                  color="green" class="q-my-sm text-grey-8"/>
                        <q-input v-if="isPW" ref="cPw" v-model.trim="form.password" type="password" class="q-mt-sm"
                                 :label="$t('customer.pw')" maxlength="20" counter :placeholder="$t('customer.pw')"
                                 outlined
                                 :rules="[val => !!val || $t('msg.input_msg'), val => val.length<=20&&val.length>=4 || $t('customer.msg_pw')]"
                                 lazy-rules/>
                        <q-input v-if="isPW" ref="cPw1" v-model.trim="form.password1" type="password" class="q-mt-sm"
                                 :label="$t('customer.pw1')" maxlength="20" counter :placeholder="$t('customer.pw1')"
                                 outlined
                                 :rules="[val => !!val || $t('msg.input_msg'), val => val.length<=20&&val.length>=4 || $t('customer.msg_pw'), val => val===form.password || $t('customer.err2')]"
                                 lazy-rules/>
                    </div>
                </q-card-section>
                <q-card-actions align="right" class="bg-white text-teal">
                    <q-btn :label="$t('close')" flat color="primary" class="q-mr-md" v-close-popup/>
                    <q-btn @click="confirm()" :label="$t('ok')" :disable="btnDisable" icon="fas fa-check"
                           color="primary"/>
                </q-card-actions>
            </q-card>
        </q-dialog>

    </q-page>
</template>
<script>
    import SparkMD5 from 'spark-md5'
    var stringOptions = []
    export default {
        name: 'customer',
        data() {
            return {
                // 储存电话区号
                nations: null,
                keyword: null,
                selected: [],
                total: 0,
                curPage: 1,
                page: {page: 1, rowsPerPage: 20},
                loading: false,
                columns: [{name: 'id', field: 'id', align: 'left',sortable: true},
                    {name: 'customerName', field: 'customerName', align: 'left', sortable: true},
                    {name: 'timeZone', field: 'timeZone', align: 'left', sortable: true},
                    {name: 'createTime', field: 'createTime', align: 'left', sortable: true},
                    {name: 'updateTime', field: 'updateTime', align: 'left', sortable: true},
                    {name: 'opt', field: 'opt', align: 'left'},
                ],
                listData: [],
                dTitle: this.$t('customer.dialog'),
                dialogType: 0,
                dialogStatus: false,
                dialogStatus2: false,
                selIndex: 0,
                personList: [],
                isPW: false,
                content: {
                    customerName: null,
                    timeZone: 'UTC+8',
                    userId: null,
                    account: null,
                    password: null,
                    user: null,
                    password1: null,
                    email: null,
                    phone: null,
                    logoPath: null,
                    language: 'zh-CN'
                },
                form: {},
                adminType: 0,
                userOpt: stringOptions,
                btnDisable: false,
                // 手机国际区号数据源
                nationsOpt: this.$t('customer.nations'),
                logoAraedisplay: false, // logo区域展示
                logoFile: null, // logo暂存
                logolistdata:{},
                logoUploadStatus: false, 
                serverList: [],
                serverUrl: null,
                selServer: null,
                imgDialogDisaplay: false, // logo缩略图显示
                logoAccept: '.jpg, .jpeg, .bmp ,.png, .svg, image/bmp, image/jpeg, image/jpg, image/png',
            }
        },
        props: ['lang', 'user'],
        filters: {
            parseDateTime(time) {
                return time ? parseDateTime(time) : time;
            }
        },
        watch: {
            lang(val, oldVal) {
                this.columns = this.columns;
            },
            pageCount(val, oldVal) {//选每页数量 size
                if (val) {
                    this.curPage = 1;
                    this.getData(this.curPage);
                }
            },
            selServer(val){
		        if(val) this.getServerUrl();
	        }
        },
        computed: {
            	screenType() {
      return _isPC(); //this.$q.platform.is.desktop
    },
            nextPage() {
                return this.curPage >= Math.ceil(this.total / this.page.rowsPerPage);
            },
            totalPage() {
                return Math.ceil(this.total / this.page.rowsPerPage);
            },
            pageCount() {
                return this.page.rowsPerPage;
            }
        },
        created() {
            this.form = JSON.parse(JSON.stringify(this.content));
            if (localStorage.getItem("AS_token") && localStorage.getItem("AS_token").length > 0) {
                this.getUsers();
                this.getMsServer()
                this.getData(1);
            } else {
                this.$router.replace('/');//login
            }
        },
        methods: {
            filterFn (val, update) {
                if (val === '') {
                    update(() => {
                        this.userOpt = stringOptions
                    })
                    return
                }
                update(() => {
                    const needle = val.toLowerCase()
                    this.userOpt = stringOptions.filter(v => v.name.toLowerCase().indexOf(needle) > -1)
                })
            },
            // 手机号码区号检索
            filterFnNations(val, update, abort){
                update(
                    () => {
                        if(val === ''){
                            this.nationsOpt = this.$t('customer.nations')
                        }else{
                            const needle = val.toLowerCase()
                            this.nationsOpt = this.$t('customer.nations').filter(val => val.name.toLowerCase().indexOf(needle) > -1)
                        }
                    }
                )
            },
            // 触发上传图片框
            add(){
                setTimeout(()=>{
			        document.getElementsByClassName('q-uploader__input')[0].click();
		        },14);
            },
            // 添加图片
            addFiles(files){
                let file = files[0]
                this.logoFile = file
                if(window.FileReader){
                      var reader = new FileReader();
                    reader.readAsDataURL(file)
                    reader.onloadend = (e) => {
                        // 未上传钱，本地保存预览
                        let temp={}
                        temp.type= file.type
                        temp.size= file.size
                        temp.name= file.name
                        temp.sizeLabel = file.__sizeLabel
                        temp.src = e.target.result || file.__img.src
                        if(file.__img.width/file.__img.height !== 4/1){
                            this.$q.dialog({
                            title: '提示',
                            message: '图片不符合长宽比为4：1，可能效果会变形，是否继续？',
                            cancel: true,
                            persistent: true
                          }).onOk(() => {
                            this.logolistdata = temp
                            this.logoUploadStatus = true
                            this.uploadMS()
                          }).onCancel(() => {
                            this.picRemove()
                            return
                          })
                        }else{
                            this.logolistdata = temp
                            this.logoUploadStatus = true
                            this.uploadMS()
                        }
                    }
                }else{
                    this.$notify(2,'请使用拥有FileReader 浏览器使用此功能', null)
                }
            },
            // 清除图片列表
            picRemove(){
                this.logolistdata = []
                this.form.logoPath = null
                if(this.$refs.upload){
                    this.$refs.upload.removeQueuedFiles()
                }
                this.logoUploadStatus = false
            },
            // 获取服务器URL列表信息
            getMsServer(){
	        	var request = {};
	        	request.type = 'MS';
	        	request.paging = { index:0, count:-1, sort:'desc' };
	        	this.$ajax(1,'post',true,'/server/list',request).then((res)=>{
                    this.serverList = res.data
			        if(this.serverList.length>0) this.selServer = JSON.parse(JSON.stringify(this.serverList[0].id));
	        	}).catch((err)=>{
                    console.log(err)
			        this.$emit('islogin',0,err)
                })
            },
            // 获取某个服务器URL
            getServerUrl(){
                let request = {}
                this.$ajax(1,'get',true,'/server/getServerUrl/'+ this.selServer,null).then((res)=>{
                    if(res.data.serverUrl){
                        this.serverUrl = res.data.serverUrl;
			        }
                }).catch((err) => {
                    console.log(err)
			        this.$emit('islogin',0,err);
                })
            },
            // 上传照片
            uploadMS(){
                let request = new FormData();// 创建form对象
                request.append('fileName',this.logoFile)
                request.append('creater', this.user.name)
                if(this.serverUrl){
                    let Auth = '7e7868efb2f69cd0cafc530202bf50e8'
                    this.$http.post( this.serverUrl + 'v1/media/mediaUpload',request,{
                        headers: {
                            'Authorization': Auth
                        }
                    }).then((res)=>{
                        this.$notify(1, '上传成功', null ,false);
                        let picId = res.data.data.id;
                        this.form.logoPath = this.serverUrl + 'v1/media/showMedia/' + picId;
                    }).catch((err)=>{
                        this.picRemove()
                        console.log(err)
                    })
		        }else{
		        	this.$notify(2,'获取上传地址失败！',null,false);
		        }
            },
            md5(str) {
                var spark = new SparkMD5();
                spark.append(str);
                var md5Str = spark.end();
                return md5Str;
            },
            keyEnter(type, e) {//输入限制
                if (type == 0) {//手机
                    e.target.value = e.target.value.replace(/[^\d]/g, '');
                } else if (type == 1) {//邮箱
                    e.target.value = e.target.value.replace(/[^a-zA-Z0-9\.\@\_]/g, '');
                }
            },
            valid(type, val) { //输入验证
                if (type === 0) {
                    // return new RegExp(/^\s*1\d{10}\s*$/).test(val)
                    return new RegExp(/^\d*$/).test(val)
                } else if (type === 1) {
                    // return new RegExp(/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/).test(val)
                    return new RegExp(/^[a-zA-Z0-9]+([\.\-_]*[0-9a-zA-Z]+)*@[a-zA-Z0-9]+(\.[a-zA-Z0-9]{2,3}?)+$/).test(val)
                }
            },
            getWH(val) {
                if (val && val.indexOf('width') != -1) {
                    val = eval('(' + val + ')');
                    val = val.width + ' * ' + val.height;
                }
                return val;
            },
            openDialog(type) {
                this.dialogType = type;
                this.dialogStatus = true;
                
            },
            getUsers() { //获取客户管理员列表
                var request = {};
                //request.ids = [];
                request.paging = {index: 0, count: -1, sort: 'desc'};
                this.$ajax(1, 'post', true, '/clientUser/list', request).then((res) => {
                    if (res && res.data) {
                        this.userOpt = res.data;
                        stringOptions = res.data
                    }
                }).catch((err) => {
                    console.log(err)
                    this.$emit('islogin', 0, err);
                })
            },
            getData(index) {
                this.listData = [];
                this.loading = true;
                var request = {};
                //request.ids = [];
                if (this.keyword) request.keyword = this.keyword;
                request.paging = {
                    index: (index - 1) * this.page.rowsPerPage,
                    count: this.page.rowsPerPage,
                    sort: 'desc'
                };
                this.$ajax(1, 'post', true, '/customer/list', request).then((res) => {
                    this.listData = res.data;
                    this.total = res.paging.total;
                    setTimeout(() => {
                        this.loading = false
                    }, 800);
                }).catch((err) => {
                    console.log(err)
                    setTimeout(() => {
                        this.loading = false
                    }, 800);
                    this.$emit('islogin', index == 1 ? 0 : 1, err);
                    //if(err.code) this.$notify(2,err.msg,null);
                })
            },
            btnClick(type, index) {
                if (type === 0) {//添加
                    this.form = JSON.parse(JSON.stringify(this.content));
                    this.logoAraedisplay = false
                } else if (type === 1 || type == 3) {//修改/查看
                    this.form = JSON.parse(JSON.stringify(this.listData[index]));
                    this.$ajax(1, 'get', true, '/customer/' + this.form.id, null).then((res) => {
                        if (res && res.data) {
                            this.form = res.data;
                            if(res.data.logoPath == null){
                                this.form.logoPath = ''
                            }
                        }
                    }).catch((err) => {
                    })
                } else if (type === 2) {//删除
                    this.$q.dialog({
                        title: this.$t('msg.prompt'),
                        message: this.$t('customer.msg_del') + this.listData[index].customerName + ' ?',
                        persistent: true,
                        cancel: true,
                    }).onOk((result) => {

                        this.$ajax(1, 'delete', true, '/customer/' + this.listData[index].id, null).then((res) => {
                            this.getData(this.curPage);
                            this.$notify(1, this.$t('customer.ok_del'), null);
                        }).catch((err) => {
                            console.log(err)
                            this.$emit('islogin', 1, err);
                            //if(err.code) this.$notify(2,err.msg,null);
                        })
                    }).onCancel((err) => {
                    })
                } else if (type === 4) {//人员管理
                    this.form = JSON.parse(JSON.stringify(this.listData[index]));
                    this.selIndex = index;
                    this.personList = [];
                    var request = {};
                    request.customerId = this.form.id;
                    request.paging = {index: 0, count: -1, sort: 'desc'};
                    this.$ajax(1, 'post', true, '/clientUser/findClientUserListByCustomerId ', request).then((res) => {
                        if (res && res.data && res.data.length > 0) {
                            var data = JSON.parse(JSON.stringify(res.data));
                            for (var i = 0; i < res.data.length; i++) {
                                const num = 1;
                                if (res.data[i].relationType === "DMAS_ADMIN") {
                                    data.splice(i, num);
                                    data.unshift(res.data[i]);
                                    num++;
                                    // break;
                                }
                            }
                            this.personList = data;
                        }
                        this.openDialog(type);
                    }).catch((err) => {
                        this.openDialog(type);
                    })
                } else if (type === 5) { //修改客户管理员信息
                    this.form = JSON.parse(JSON.stringify(this.personList[index]));
                    this.isPW = false;
                    this.dialogStatus2 = true;
                } else if (type === 6) { //删除客户普通人员
                    this.$q.dialog({
                        title: this.$t('msg.prompt'),
                        message: this.$t('customer.msg_del1') + this.personList[index].userName + ' ?',
                        persistent: true,
                        cancel: true,
                    }).onOk((result) => {
                        this.$ajax(1, 'delete', true, '/clientUser/' + this.personList[index].id + '/' + this.form.id, null).then((res) => {
                            this.btnClick(4, this.selIndex);//this.getData(this.curPage);
                            this.$notify(1, this.$t('customer.ok_del1'), null);
                        }).catch((err) => {
                            console.log(err)
                            this.$emit('islogin', 1, err);
                            //if(err.code) this.$notify(2,err.msg,null);
                        })
                    }).onCancel((err) => {
                    })
                }
                if (type != 2 && type < 4) this.openDialog(type);                
            },
            confirm() {
                if (this.dialogType === 0) {//添加
                    // 手机号码加入区号
                    let resPhone = this.nations + ' ' + this.form.phone
                    // console.log(resPhone)
                    this.$refs.name.validate();
                    var addError = false;
                    // 0 选择客户管理与 1为创建新客户管理员
                    if (this.adminType === 0) {
                        this.$refs.admin.validate();
                        if (this.$refs.name.hasError || this.$refs.admin.hasError) {
                            addError = true;
                        }
                    } else if (this.adminType === 1) {
                        this.$refs.account.validate();
                        this.$refs.user.validate();
                        // this.$refs.email.validate();
                        // this.$refs.phone.validate();
                        this.$refs.pw.validate();
                        this.$refs.pw1.validate();
                        if (this.$refs.name.hasError || this.$refs.account.hasError || this.$refs.user.hasError || this.$refs.email.hasError || this.$refs.phone.hasError || this.$refs.pw.hasError || this.$refs.pw1.hasError) {
                            addError = true;
                        }
                    }
                    if (addError) {
                        this.$notify(2, this.$t('msg.input_err'), null);
                        return
                    } else {
                        this.btnDisable = true;
                        var request = {};
                        request.customerName = this.form.customerName;
                        request.timeZone = this.form.timeZone;
                        request.logoPath = this.form.logoPath;
                        request.language = this.form.language;
                        if (this.adminType === 0) {
                            request.userIds = this.form.userId;
                        } else if (this.adminType === 1) {
                            request.account = this.form.account;
                            request.password = this.md5(this.form.password);
                            request.userName = this.form.user;
                            request.email = this.form.email;
                            // request.phone = this.form.phone;
                            request.resPhone = this.form.phone;
                        }
                        this.$ajax(1, 'put', true, '/customer', request).then((res) => {
                            this.getData(this.curPage);
                            this.dialogStatus = false;
                            this.btnDisable = false;
                            this.$notify(1, this.$t('customer.ok_add'), null);
                        }).catch((err) => {
                            console.log(err)
                            this.$emit('islogin', 1, err);
                            this.btnDisable = false;
                            //if(err.code) this.$notify(2,err.msg,null);
                        })
                    }
                } else if (this.dialogType === 1) {//修改
                    this.$refs.name.validate();
                    if (this.$refs.name.hasError) {
                        this.$notify(2, this.$t('msg.input_err'), null);
                        return
                    } else {
                        this.btnDisable = true;
                        var request = {};
                        request.customerName = this.form.customerName;
                        request.timeZone = this.form.timeZone;
                        request.logoPath = this.form.logoPath;
                        request.language = this.form.language;
                        this.$ajax(1, 'post', true, '/customer/' + this.form.id, request).then((res) => {
                            this.getData(this.curPage);
                            this.dialogStatus = false;
                            this.btnDisable = false;
                            this.picRemove();
                            this.$notify(1, this.$t('customer.ok_modify'), null);
                        }).catch((err) => {
                            console.log(err)
                            this.$emit('islogin', 1, err);
                            this.btnDisable = false;
                            //if(err.code) this.$notify(2,err.msg,null);
                        })
                    }
                } else if (this.dialogStatus2) {//修改管理员
                    //this.$refs.cAccount.validate();
                    this.$refs.cName.validate();
                    // this.$refs.cEmail.validate();
                    // this.$refs.cPhone.validate();
                    if (this.$refs.cName.hasError || this.$refs.cEmail.hasError || this.$refs.cPhone.hasError) {
                        this.$notify(2, this.$t('msg.input_err'), null);// this.$refs.cAccount.hasError ||
                        return
                    } else {
                        var request = {};
                        //request.account = this.form.account;
                        request.userName = this.form.userName;
                        request.email = this.form.email;
                        request.phone = this.form.phone;
                        if (this.isPW) { //重置密码
                            this.$refs.cPw.validate();
                            this.$refs.cPw1.validate();
                            if (this.$refs.cPw.hasError || this.$refs.cPw1.hasError) {
                                this.$notify(2, this.$t('msg.input_err'), null);
                                return
                            }
                            request.password = this.md5(this.form.password);
                        }
                        this.btnDisable = true;
                        this.$ajax(1, 'post', true, '/clientUser/updateInfo/' + this.form.id, request).then((res) => {
                            this.btnClick(4, this.selIndex);//this.getData(this.curPage);
                            this.getUsers();
                            this.dialogStatus2 = false;
                            this.btnDisable = false;
                            this.$notify(1, this.$t('customer.ok_modify1'), null);
                        }).catch((err) => {
                            console.log(err)
                            this.$emit('islogin', 1, err);
                            this.btnDisable = false;
                            //if(err.code) this.$notify(2,err.msg,null);
                        })
                    }
                }
            },
            pageClick(type) {//点击页数 type:0-,1+
                this.curPage = type ? this.curPage + 1 : this.curPage - 1;
                if (this.curPage > 0 && this.total !== 0 && this.listData.length < this.total) {
                    this.getData(this.curPage);
                }
            },
        }
    }
</script>
